<template>
  <StyledModal :visible="visible" :title="`新建`" @close="close" @submit="submit" :submitLoading="submitLoading">
    <el-form class="form_box" ref="formRef" :model="formModel.form" label-width="120px">
      <el-form-item label="选择医生" prop="doctorCode" :rules="[{ required: true, message: '请选择医生' }]">
        <FetchSelect v-model="formModel.form.doctorCode" api="/web/system/doctorncp/getDoctorList" valueKey="doctorCode" textKey="doctorName" />
      </el-form-item>
    </el-form>
  </StyledModal>
</template>

<script>
import { reactive, ref, computed } from 'vue'
import { cloneDeep } from 'lodash'
import StyledModal from '@/components/modal/StyledModal'
import ImgUpload from '@/components/ImgUpload'
import FetchSelect from '@/components/FetchSelect'
import { validateFormRef } from '@/common/utils_element'
import request from '@/utils/request'

const defaultForm = {
  doctorCode: '',
}

export default {
  emits: ['successAdd', 'successEdit'],
  setup(_, ctx) {
    const visible = ref(false)
    const submitLoading = ref(false)

    const formRef = ref(null)
    const formModel = reactive({
      form: cloneDeep(defaultForm),
    })

    function open() {
      visible.value = true
    }

    function close() {
      visible.value = false
      formModel.form = cloneDeep(defaultForm)
    }

    // 提交
    async function submit() {
      await validateFormRef(formRef)

      const postData = {
        ...formModel.form,
      }
      submitLoading.value = true
      request({
        url: '/web/system/doctorncp/createDoctorNcp',
        data: postData,
      })
        .finally(() => {
          submitLoading.value = false
        })
        .then(() => {
          ctx.emit('successAdd')
          close()
        })
    }

    return {
      visible,
      submitLoading,
      open,
      close,
      submit,
      //
      formRef,
      formModel,
    }
  },
  components: { StyledModal, FetchSelect, ImgUpload },
}
</script>

<style lang="less" scoped>
.form_box {
  width: 90%;
}
</style>
